import { WorkAssignmentSourceType } from "features/WorkAssignments/constants/work-assignment.constants";
import * as Yup from "yup";

export const schema = Yup.object({
  sourceType: Yup.mixed<WorkAssignmentSourceType>()
    .oneOf(Object.values(WorkAssignmentSourceType))
    .required("Source type is required"),

  sourceId: Yup.number(),

  isReassign: Yup.boolean().optional(),

  plannedStartDate: Yup.date()
    .required("The start date field is required")
    .typeError("Invalid start date")
    .when("sourceType", {
      is: WorkAssignmentSourceType.AMC_VISIT,
      otherwise: (s) =>
        s.min(
          new Date(new Date().setHours(0, 0, 0, 0)),
          "Planned start date must be today or later",
        ),
    }),

  plannedEndDate: Yup.date()
    .nullable()
    .optional()
    .typeError("Invalid end date")
    .test(
      "end-after-start",
      "Planned end date must be same as or greater than planned start date",
      function (plannedEndDate) {
        if (!plannedEndDate) return true;
        const plannedStartDate = this.parent?.plannedStartDate as
          | Date
          | string
          | null
          | undefined;
        if (!plannedStartDate) return true;
        return (
          new Date(plannedEndDate).getTime() >= new Date(plannedStartDate).getTime()
        );
      },
    ),

  remarks: Yup.string().nullable().optional(),

  role: Yup.string().nullable().optional(),

  userIds: Yup.array()
    .of(Yup.number().required())
    .min(1, "At least one user is required.")
    .required("At least one user is required."),
});

export default schema;
